export interface SettingsPaths {
  index: string;
  user: string;
  workspace: string;
}

export const paths: SettingsPaths = {
  index: "/settings",
  user: "/settings/user/profile",
  workspace: "/settings/workspace/general",
};
